import React from "react"
import { VStack, HStack, Text, Tag, Divider } from "@chakra-ui/react"
import { MDXProvider } from "../../contexts"
import { MDXRenderer } from "gatsby-plugin-mdx"

export default function Body({ current, date, tag }) {
  return (
    <MDXProvider>
      <VStack direction="column" my={12} spacing={12}>
        <HStack spacing={4}>
          <Tag variant="outline" colorScheme="primary">
            {tag}
          </Tag>
          <Text size="xs">{date}</Text>
        </HStack>

        <Divider />

        <VStack w="full" spacing={6}>
          <MDXRenderer>{current.body}</MDXRenderer>
        </VStack>

        <Divider />
      </VStack>
    </MDXProvider>
  )
}
